import React,{useState} from "react";
import {Link} from "react-router-dom";
import {Dropdown} from 'react-bootstrap';
import {GiHamburgerMenu} from "react-icons/gi";

export const ScreenLink = ({ handleAboutScroll, videoResume, socialMediaCapabilities }) => {

    return( <div className="d-flex gap-4 justify-content-end align-items-center">
        {/*<Link to="#" className="nav_link active_link">HOME</Link>*/}

        {/*<Link to="#" className="nav_link" onClick={handleAboutScroll}>WHY REZMAZE</Link>*/}
        {/*<Link to="#" className="nav_link">CONTACT US</Link>*/}
            <div className="nav_link d-inline-block">
                <Dropdown>

                    <Dropdown.Toggle
                        style={{
                            backgroundColor: 'transparent',
                            border: 'transparent',
                            padding: '0px',
                            color: '#1DA1F2',
                        }}
                    >
                        <span className="nav_link">WHATS NEW</span>
                    </Dropdown.Toggle>
                    <Dropdown.Menu style={{ zIndex: 9999 }}>
                        <Dropdown.Item as="button" type="button" style={{ color: '#1DA1F2' }} onClick={videoResume}>
                            VIDEO RESUME
                        </Dropdown.Item>
                        <Dropdown.Item as="button" type="button" style={{ color: '#1DA1F2' }} onClick={socialMediaCapabilities}>
                            SOCIAL MEDIA CAPABILITIES
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div>
        <Link to="/login" className="nav_link" style={{ color: '#1DA1F2' }}>
            LOGIN
        </Link>
        <Link to="/register" className="nav_link" style={{ color: '#1DA1F2' }}>
            SIGN UP
        </Link>
        <style>
            {`
              .dropdown-toggle::after {
                color: #003580;
              }
        
              .dropdown-menu {
                border: none;
                background-color: #f8f9fa;
              }
        
              .dropdown-item {
                color: #003580;
                padding: 10px 20px;
                // transition: background-color 0.3s ease;
              }
        
              .dropdown-item:hover {
                background-color: #e9ecef;
              }
            `}
        </style>
    </div>
    )
}


export const TabScreen = ({ handleAboutScroll, videoResume, socialMediaCapabilities }) => {
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    const toggleDropdown = () => {
        setIsDropdownOpen(!isDropdownOpen);
    };

    return (
        <>
            <Dropdown data-bs-theme="dark" show={isDropdownOpen} onToggle={toggleDropdown}>
                <Dropdown.Toggle
                    id="dropdown-button-dark-example1"
                    variant="secondary"
                    className="d-flex align-items-center"
                >
                    <GiHamburgerMenu size={20} />
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item as={Link} to="/" active className="nav_link">
                        HOME
                    </Dropdown.Item>


                    <Dropdown>
                        <Dropdown.Toggle variant="none" id="dropdown-whats-new" className="nav_link">
                            WHATS NEW
                        </Dropdown.Toggle>

                        <Dropdown.Menu>
                            <Dropdown.Item as="button" type="button" onClick={videoResume}>VIDEO RESUME</Dropdown.Item>
                            <Dropdown.Item as="button" type="button" onClick={socialMediaCapabilities}>SOCIAL MEDIA CAPABILITIES</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <Dropdown.Divider />

                    <Dropdown.Item as={Link} to="/login" className="nav_link">
                        LOGIN
                    </Dropdown.Item>

                    <Dropdown.Item as={Link} to="/register" className="nav_link">
                        SIGN UP
                    </Dropdown.Item>
                </Dropdown.Menu>
            </Dropdown>
            <style>
                {`
              .dropdown-toggle::after {
               display:none;
              }
            `}
            </style>

        </>
    );
}
